import React, {Component} from 'react';
import PropTypes from "prop-types";
import Lightbox from 'react-images';

class UecareLightBox extends Component {

    static propTypes = {
        images: PropTypes.array.isRequired,
    };

    state = {
        lightboxIsOpen: false,
        currentImage: 0,
    };

    openLightbox(index, event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({
            currentImage: index,
            lightboxIsOpen: true,
        });
    }

    async closeLightbox() {

        if (this.props.onClose) await this.props.onClose();
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    render() {

        return (
            <Lightbox
                {...this.props}
                images={this.props.images}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious.bind(this)}
                onClickNext={this.gotoNext.bind(this)}
                onClose={this.closeLightbox.bind(this)}
            />
        );
    }
}

export default UecareLightBox;



// WEBPACK FOOTER //
// ./src/components/UecareLightBox.js